// extracted by mini-css-extract-plugin
export default {"dateSwitch":"DateSwitch_dateSwitch__UKJ1R","datePickerArea":"DateSwitch_datePickerArea__6Jg2f","label":"DateSwitch_label__u6s0L"};